export default __webpack_public_path__ + "static/media/instument.712611c7.jpg";